<template>
  <div
    :class="[
      'upload',
      { img_default: btnImageSize === 'default' },
      { img_small: btnImageSize === 'small' },
    ]"
  >
    <a-upload
      list-type="picture-card"
      :customRequest="upload"
      :file-list="imgList"
      :beforeUpload="beforeUpload"
      :remove="removeImg"
      @change="changeImgList"
      :showUploadList="{ showPreviewIcon: false, showRemoveIcon: true }"
    >
      <template v-if="imgList.length < this.max">
        <div class="img_wrapper btn_img" style="width: 100%; height: 100%">
          <img :src="btnImage" />
        </div>
      </template>
    </a-upload>

    <div class="desc_wrapper">
      <slot name="desc"></slot>
      <span>({{ `${imgList.length}/${this.max}张` }})</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadImageList",
  model: {
    prop: "uploadImg",
    event: "upload",
  },
  props: {
    uploadImg: {
      type: Array,
    },
    imgKey: {
      type: String,
      required: false,
      default: "complaint",
    },
    max: {
      type: Number,
      required: false,
      default: 3,
    },
    btnImage: {
      type: String,
      required: false,
      default: require("@/assets/images/deal-manage/upload_img.png"),
    },
    btnImageSize: {
      type: String,
      required: false,
      default: "default",
    },
    desc: {
      type: String,
      required: false,
    },
    maxSize: {
      type: Number,
      default: 5 * 1024 * 1024,
    },
  },
  data() {
    return {
      imgList: [],
      doneList: [],
      limitTypes: ["image/jpeg", "image/gif", "image/bmp", "image/png"],
    };
  },
  watch: {
    uploadImg: {
      handler(val) {
        if (val && val.length > 0) {
          this.imgList = this.formatImage(val);
          this.doneList = val;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    formatImage(val) {
      var res = [];

      for (var i = 0; i < val.length; i++) {
        res.push({
          uid: i,
          name: this.getFileName(val[i]),
          status: "done",
          url: val[i],
          key: val[i]
            .replace("img2.91jf.com/", "")
            .replace("https://", "")
            .replace("https://", ""),
          type: this.getImageType(val[i]),
          size: 0,
        });
      }

      return res;
    },
    beforeUpload(file) {
      if (!this.limitTypes.includes(file.type)) {
        this.$message.error("上传图片仅支持JPG、GIF、PNG格式");
        return false;
      }
      if (this.maxSize < file.size) {
        this.$message.error("图片大小最大不能超过5M");
        return false;
      }
      return true;
    },
    changeImgList({ fileList }) {
      this.imgList = fileList.filter((file) => {
        return this.limitTypes.includes(file.type) && file.size <= this.maxSize;
      });
    },
    upload(file) {
      const nanoid = this.$util.getId();
      const { name } = file.file;
      const suffix = name.substr(name.indexOf("."));
      const key = `member/${this.imgKey}/${file.file.uid + nanoid + suffix}`;
      file.file.key = key;
      this.$util
        .cosUpload(key, file.file, ({ loaded }) => {
          let curFile = this.imgList.find((item) => item.uid === file.file.uid);
          curFile.percent = loaded;
        })
        .then((key) => {
          let curFile = this.imgList.find((item) => item.uid === file.file.uid);
          curFile.status = "done";
          this.doneList.push(key);
          this.$emit("upload", this.doneList);
        })
        .catch(() => {
          let curFile = this.imgList.find((item) => item.uid === file.file.uid);
          curFile.status = "error";
        });
    },
    removeImg(file) {
      // this.$util.cosDel(file.key)

      for (var i = 0; i < this.doneList.length; i++) {
        if (this.doneList[i] == file.url) {
          this.doneList.splice(i, 1);
        }
      }

      for (var i = 0; i < this.imgList.length; i++) {
        if (this.imgList[i].key == file.key) {
          this.imgList.splice(i, 1);
        }
      }

      this.$emit("upload", this.doneList);
    },
    getFileName(url) {
      let pos = url.lastIndexOf("/");
      return url.substring(pos + 1);
    },
    getImageType(url) {
      var index = url.lastIndexOf(".");
      var ext = url.substr(index + 1);
      var res = "";

      switch (ext) {
        case "jpeg":
          res = "image/jpeg";
          break;
        case "jpg":
          res = "image/jpeg";
          break;
        case "gif":
          res = "image/gif";
          break;
        case "bmp":
          res = "image/bmp";
          break;
        case "png":
          res = "image/png";
          break;
        default:
          break;
      }

      return res;
    },
  },
};
</script>

<style scoped>
.upload {
  display: flex;
  align-items: center;
}

.desc_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  box-sizing: border-box;
  padding-bottom: 10px;
}
.upload >>> .ant-upload-picture-card-wrapper {
  display: inline-flex;
  position: relative;
  width: auto;
}

.upload >>> .ant-upload.ant-upload-select-picture-card > .ant-upload {
  padding: 0;
}

.img_default .btn_img {
  width: 82px;
  height: 82px;
}

.img_default >>> .ant-upload.ant-upload-select-picture-card {
  width: 84px;
  height: 84px;
}

.img_default >>> .ant-upload-list-picture-card-container {
  width: 84px;
  height: 84px;
}
.img_default >>> .ant-upload-list-picture-card .ant-upload-list-item {
  width: 84px;
  height: 84px;
}

.img_small >>> .ant-upload.ant-upload-select-picture-card {
  width: 60px;
  height: 60px;
}

.img_small >>> .ant-upload-list-picture-card-container {
  width: 60px;
  height: 60px;
}
.img_small >>> .ant-upload-list-picture-card .ant-upload-list-item {
  width: 60px;
  height: 60px;
}

.img_title {
  color: #333333;
  font-family: "PingFang SC";
  font-size: 13px;
  font-weight: 500;
}

>>> .ant-upload.ant-upload-select-picture-card,
.ant-upload.ant-upload-select-picture-card:hover {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/upload/UploadImageList.vue